import BaseService from "@/services/base.service";
import store from "@/store/index.js"

export default async function useStopImpersonation() {
  if (store.getters.impersonated) {
    store.commit("setImpersonation", false);
    const response = await BaseService.post("/stop-impersonation");
    store.commit("updateToken", response.data.access_token);
  }
}
